import { playPath } from '@/lib/utils'
import { IDownloadType, ILocation } from '@/lib/enums/device'
import { eventLogProducer } from '@/lib/event-logger'
import { createResource, useResource } from '@/lib/i18n'
import { Action } from '@@/action_pb'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { getUuid } from '@/lib/utils'
import Slider from '@mui/material/Slider'
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { CALCULATION_LIST } from '@/lib/constant'

const resource = createResource({
  en: {
    amount: 'Loan Amount',
    million: 'Million',
    hundred: 'Hundred',
    thousand: 'Thousand',
    months: 'Months',
    weeks: 'Weeks',
    tenor: 'Tenor',
    Installments: 'Installments per month',
    rate: '*include interest rate',
    apply: 'Apply Now',
  },
  id: {
    amount: 'Jumlah Pinjaman',
    million: 'Juta',
    hundred: 'Ratus',
    thousand: 'Ribu',
    months: 'Bulan',
    weeks: 'Minggu',
    tenor: 'Lama Pinjaman',
    Installments: 'Cicilan per bulan',
    rate: '*sudah termasuk bunga',
    apply: 'Ajukan Pinjaman',
  },
})
const Calculation = () => {
  const { t } = useResource(resource)
  const maxProduct = CALCULATION_LIST[3]
  const [installment, setInstallment] = useState<string>(maxProduct?.installment)
  const [tenor, setTenor] = useState<any>(maxProduct?.tenor)
  const [amount, setAmount] = useState<any>(maxProduct?.amount)
  const [applyUrl, setApplyUrl] = useState('')
  const { width } = useWindowSize()
  const isFromMobile = width < 1000
  const domainName = process.env.NEXT_PUBLIC_GROWTH_HOST_BACKUP || process.env.NEXT_PUBLIC_GROWTH_HOST

  useEffect(() => {
    const url =
      width < 1000
        ? `${domainName}/OFFICIAL2021/login?utm_source=OfficialWebsite&utm_campaign=Homepage_ApplyNow&cid=${getUuid()}`
        : playPath(IDownloadType.GOOGLE_PLAY, '', ILocation.HOME)
    setApplyUrl(url)
  }, [])

  const handleCount = (event: any, newValue: number | number[]) => {
    const productArr = CALCULATION_LIST.filter((item) =>
      item.amount === 50000000 ? (newValue as number) > 47000000 : (newValue as number) >= item.amount,
    )
    const product = productArr[productArr.length - 1]
    setInstallment(product?.installment)
    setTenor(product?.tenor)
    setAmount(product?.amount)
  }

  const eventClickH5 = () => {
    if (isFromMobile) {
      eventLogProducer.push({
        action: Action.APPLYNOWBUTTONCLICK,
      })
    }
  }

  return (
    <Wrapper>
      <div className="calculation-container">
        <div className="calculation-content">
          <div className="title">
            <span className="title-left">{t('amount')}</span>
            <span className="title-right">{`${amount / 1000000} ${t('million')}`}</span>
          </div>
          <Slider min={600000} max={50000000} onChange={handleCount} defaultValue={amount} />
          <div className="tip">
            <span>{`600 ${t('hundred')} ${t('thousand')}`}</span>
            <span>{`50 ${t('million')}`}</span>
          </div>
        </div>
        <div className="calculation-content">
          <div className="title">
            <span className="title-left">{t('tenor')}</span>
            <span className="title-right">{`${tenor} ${t('months')}`}</span>
          </div>
          <Slider min={2} max={12} disabled={true} value={tenor} defaultValue={tenor} />
          <div className="tip">
            <span>{`2 ${t('months')}`}</span>
            <span>{`12 ${t('months')}`}</span>
          </div>
        </div>
        <div className="calculation-btn">
          <div className="btn-title">{t('Installments')}</div>
          <div className="btn-tip">{t('rate')}</div>
          <div className="btn-result">{`Rp ${installment}`}</div>
          <a href={applyUrl} rel="noopener noreferrer nofollow" onClick={eventClickH5} target="_blank" className="btn">
            {t('apply')}
          </a>
        </div>
      </div>
    </Wrapper>
  )
}
export default Calculation

const Wrapper = styled.div`
  @media only screen and (max-width: 1000px) {
    .calculation-container {
      margin-top: 24px;
      padding: 24px 16px;
      .calculation-content {
        margin-bottom: 16px;
        .title {
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;
        }
        .tip {
          line-height: 16px;
          font-size: 12px;
        }
      }
      .calculation-btn {
        .btn-title {
          font-size: 20px;
          line-height: 28px;
          margin-top: 16px;
        }
        .btn-tip {
          font-size: 12px;
          line-height: 16px;
        }
        .btn-result {
          font-size: 28px;
          line-height: 32px;
          margin: 12px 0 16px 0;
        }
        .btn {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .calculation-container {
      width: 448px;
      height: 517px;
      padding: 32px 24px;
      margin-right: 16px;
      .calculation-content {
        margin-bottom: 24px;
        .title {
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
        }
        .tip {
          line-height: 22px;
        }
      }
      .calculation-btn {
        .btn-title {
          font-size: 24px;
          line-height: 34px;
          margin-top: 24px;
        }
        .btn-tip {
          font-size: 16px;
          line-height: 22px;
        }
        .btn-result {
          font-size: 36px;
          line-height: 48px;
          margin: 12px 0 24px 0;
        }
        .btn {
          height: 56px;
          line-height: 56px;
          font-size: 18px;
        }
      }
    }
  }
  .calculation-container {
    background: #ffffff;
    box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    .calculation-content {
      .title {
        font-weight: 500;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .title-left {
          color: #333333;
        }
        .title-right {
          color: #1cc812;
        }
      }
      .tip {
        color: #9e9e9e;
        display: flex;
        justify-content: space-between;
      }
    }
    .calculation-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-top: 1px solid #c2c2c2;
      .btn-title {
        color: #333333;
        font-weight: 500;
      }
      .btn-tip {
        color: #9e9e9e;
      }
      .btn-result {
        color: #1cc812;
        font-weight: bold;
      }
      .btn {
        background: #1cc812;
        border-radius: 8px;
        width: 100%;
        text-align: center;
        color: #ffffff;
      }
    }
    .MuiSlider-root {
      color: #1cc812 !important;
      padding: 10px 0;
      .MuiSlider-thumb {
        border: 3px solid #1cc812;
        box-sizing: border-box;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #fff;
      }
      .MuiSlider-rail {
        background: #cccccc;
        border-radius: 9px;
        width: 100%;
        height: 4px;
        opacity: 1;
      }
      .MuiSlider-track {
        height: 4px;
      }
      .MuiSlider-valueLabel {
        font-size: 12px;
      }
    }
  }
`
